module.exports = __webpack_public_path__ + "static/img/xhwb_sx.083c8f6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/xhwb_sx.png
// module id = B69w
// module chunks = 0